import { ExistingScribeModel, VisualCanvasElement, VSCAssetData, VSImageShapeOrTextElementModel } from 'js/types';

export const isPremiumImageAsset = (asset: VSCAssetData): boolean => {
  return !!asset.isPremium;
};

export const isPremiumVisualCanvasElement = (canvasElement: VisualCanvasElement): boolean => {
  if (!canvasElement || !canvasElement.element) {
    // Fixes https://sparkol.sentry.io/issues/6426011590/
    return false;
  }

  return !!canvasElement.element.isPremium;
};

const isPremiumElement = (element: VSImageShapeOrTextElementModel): boolean => {
  return !!element.isPremium;
};

export const projectContainsPremiumContent = (project: ExistingScribeModel): boolean => {
  const elements = project.elements.filter(el => el.type === 'Image');

  return elements.some(element => isPremiumElement(element));
};
